import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getCompanies = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/company?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const createCompany = async (data: any) => {
  return await customFetch("v1/company", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateCompany = async (id: string, data: any) => {
  return await customFetch(`v1/company/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteCompany = async (id: string) => {
  return await customFetch(`v1/company/${id}`, {
    method: "DELETE",
  });
};
